import posthog from "posthog-js";
import { shouldRecordPostHog } from "./posthog-env";
import { browserPostHogConfig } from "./posthog-browser-config";
import { isExpectedRequestError, safeException } from "./error-reporting";

let started = false;
let ready = false;
const listeners = new Set<(ready: boolean) => void>();
const reported = new WeakSet<object>();

export function initializeBrowserTelemetry() {
  if (started || !shouldRecordPostHog()) return;
  const key = process.env.NEXT_PUBLIC_POSTHOG_KEY?.trim();
  const host = process.env.NEXT_PUBLIC_POSTHOG_HOST?.trim();
  if (!key || !host) return;
  started = true;
  try {
    posthog.init(key, {
      ...browserPostHogConfig(window.location.hostname),
      api_host: host,
      loaded: () => {
        ready = true;
        for (const listener of listeners) listener(true);
      },
    });
  } catch {
    started = false;
    // Telemetry initialization must not prevent application hydration.
  }
}

export function subscribeBrowserTelemetry(listener: (ready: boolean) => void) {
  listeners.add(listener);
  initializeBrowserTelemetry();
  listener(ready);
  return () => {
    listeners.delete(listener);
  };
}

export function reportBrowserFailure(error: unknown, operation: string) {
  if (isExpectedRequestError(error)) return;
  if (error && typeof error === "object") {
    if (reported.has(error)) return;
    reported.add(error);
  }
  try {
    initializeBrowserTelemetry();
    if (!started) return;
    posthog.captureException(safeException(error), { operation });
  } catch {
    // The application's recovery controls must survive SDK failures.
  }
}
